// extracted by mini-css-extract-plugin
export default {"parent":"SpinnerOverla_parent__QUHA9","parentSpinnerContainer":"SpinnerOverla_parentSpinnerContainer__7zpcb"};